import {
  RAISED_OVERLAY_DESKTOP,
  RAISED_OVERLAY_MOBILE,
} from "./WhyNotSliderPage";

// /fb02 — LGBTQ+ variant of the /whynot slider for paid-social
// campaigns targeting gay men. Same layout/behavior as /fb01;
// only the copy and imagery differ.
const HERO_DUSK = "/images/fb02/hero-dusk.jpg";
const PINK_WALL = "/images/fb02/pink-wall.jpg";
const GLASSES_LAUGH = "/images/fb02/glasses-laugh.jpg";
const FACES_CLOSEUP = "/images/fb02/faces-closeup.jpg";
const GARDEN_COUPLE = "/images/fb02/garden-couple.jpg";

const FB02_SLIDES = [
  {
    id: 0,
    intro: true,
    image: HERO_DUSK,
    overlay: "bottom",
    eyebrow: "Because you have better things to do...",
    title: "Your personal life shouldn't feel like a part-time job.",
    body: [
      "Dating shouldn't require managing multiple apps, endless conversations, and constantly starting over. HAEVN sits between traditional dating apps and expensive matchmaking, helping you meet people who are actually looking for the same things you are.",
    ],
  },
  {
    id: 1,
    image: PINK_WALL,
    overlay: "bottom",
    overlayDesktop: RAISED_OVERLAY_DESKTOP,
    overlayMobile: RAISED_OVERLAY_MOBILE,
    eyebrow: "What is this?",
    title: "It's not a dating app. It's a dating service.",
    body: [
      "Meeting other gay men has never been easier. Meeting the right one is still surprisingly hard. HAEVN doesn't ask you to search through hundreds of profiles. You tell us who you are, what you're looking for, and we notify you when we find highly compatible matches.",
    ],
  },
  {
    id: 2,
    image: GLASSES_LAUGH,
    overlay: "bottom",
    overlayDesktop: RAISED_OVERLAY_DESKTOP,
    overlayMobile: RAISED_OVERLAY_MOBILE,
    eyebrow: "How does it work?",
    title: "Your rules come first.",
    body: [
      "Before we ever introduce two people, we remove the obvious mismatches. Looking for a relationship? Want monogamy? Prefer someone nearby? Have specific dealbreakers? Those aren't preferences we ignore. They're where matching begins. Once those align, we calculate compatibility and only introduce people who meet your standards.",
    ],
    video: {
      src: "/videos/whynot-overview.mp4",
      label: "Watch the overview",
    },
  },
  {
    id: 3,
    image: FACES_CLOSEUP,
    overlay: "bottom",
    overlayDesktop: RAISED_OVERLAY_DESKTOP,
    overlayMobile: RAISED_OVERLAY_MOBILE,
    // Portrait 3:4 source — on desktop landscape viewports the cover
    // crop is a horizontal band; bias it up so the eyes stay in frame.
    desktopObjectPosition: "center 38%",
    eyebrow: "Would this work for me?",
    title: "Built for people who are tired of wasting time.",
    body: [
      "Most dating apps optimize for more conversations. HAEVN optimizes for better introductions. Spend fifteen minutes completing your survey once, then let us do the searching while you get back to living your life.",
    ],
  },
  {
    id: 4,
    image: GARDEN_COUPLE,
    overlay: "bottom",
    // Stronger closing-card gradients (same as /fb01's final slide) so
    // the numbered list + CTA always read over the imagery.
    overlayDesktop:
      "linear-gradient(to top, rgba(8, 11, 24, 0.97) 0%, rgba(8, 11, 24, 0.90) 30%, rgba(8, 11, 24, 0.65) 55%, rgba(8, 11, 24, 0.30) 80%, transparent 100%)",
    overlayMobile:
      "linear-gradient(to top, rgba(0, 0, 0, 0.98) 0%, rgba(0, 0, 0, 0.90) 25%, rgba(0, 0, 0, 0.65) 45%, rgba(0, 0, 0, 0.30) 60%, transparent 75%)",
    // Subjects sit right-of-center in the source — keep them in frame
    // on portrait viewports.
    mobileObjectPosition: "65% center",
    hideCounter: true,
    title: "So what are you waiting for?",
    numberedList: [
      "There's no app to download.",
      "Complete one fifteen-minute survey.",
      "You never have to manage or update a profile.",
      "We send compatible matches directly to you each week.",
      "Join free. Upgrade only when you're ready to start meeting your matches.",
    ],
    cta: { label: "Take the Survey", href: "https://survey.haevn.co" },
  },
];

export default FB02_SLIDES;
